module.exports = __webpack_public_path__ + "media/images/ui__textArrowDownLight--dark-e91a0e1d9dfd92a54d9dd9c6b4edcbcb.png";